
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as loginnHf6UaBUCy38F4yExeYF_ANgwlS_9Bsvtvvio1Nx55IMeta } from "/home/bun/app/pages/auth/login.vue?macro=true";
import { default as registerK7qOGAV_45vWniurJYZ69CZXH5EsirWqdlXHC11NnFlh8Meta } from "/home/bun/app/pages/auth/register.vue?macro=true";
import { default as saml_45jwtoWXJf0_454XNOHcLHRSSJ9udmWbPjd1neuLjo8VIZO_458YMeta } from "/home/bun/app/pages/auth/saml-jwt.vue?macro=true";
import { default as authfui7vWzQm5m6z9xEjexT0j4cuXC8QV2KdZkA_9jkRboMeta } from "/home/bun/app/pages/auth.vue?macro=true";
import { default as indexW2oOzCUjUAX9OVYCf_FRg_ujkZU60Wo3sykd3ILypuoMeta } from "/home/bun/app/pages/sina/index.vue?macro=true";
import { default as indexfdzw994ukIKXJ2Eyp8Ut1BuMgK7CF2nwodm5Fct7YVsMeta } from "/home/bun/app/pages/sina/[survey]/index.vue?macro=true";
import { default as job_45clusteroe_vlPurca_fjJfnXyCyishGW6Ry67dUE_45gWwIM8raQMeta } from "/home/bun/app/pages/sina/[survey]/job-cluster.vue?macro=true";
import { default as example_45matrixP45U635MkImaUdY6Ua860t8FsMbc0ymVhcyOHMmfh34Meta } from "/home/bun/app/pages/sina/[survey]/example-matrix.ts?macro=true";
import { default as indexs9L9TqaM0PYYKktdBOS6VxivlYEbGVxbJWbYvA2eq2cMeta } from "/home/bun/app/pages/sina/[survey]/results/index.vue?macro=true";
import { default as timelinelcWK_ZTI6gZKaIe1Sch6EgJULA0CGioiNOPoqgTrMzQMeta } from "/home/bun/app/pages/sina/[survey]/results/timeline.vue?macro=true";
import { default as switching_45windows8_w1JUN4OkjidwhllRalXeAcVOwJU5hpDhENJmlIRYAMeta } from "/home/bun/app/pages/sina/[survey]/switching-windows.vue?macro=true";
import { default as nnf_45cne_45tableUTbT4_45Frru9Z6Ey2VrlAciwBozvZHf_45gAXY2j5pIHAMMeta } from "/home/bun/app/pages/sina/[survey]/results/nnf-cne-table.vue?macro=true";
import { default as _91survey_93yolFeUVDdcUCZZuyLOvunco6_459NJ5Mn9rrNEO9so87QMeta } from "/home/bun/app/pages/sina/[survey].vue?macro=true";
import { default as sinao07spVqb84g0VUqpJtTfu3bbs5u0gnrcT3dm__HhqJQMeta } from "/home/bun/app/pages/sina.vue?macro=true";
import { default as index685vuCKVdDpjasjPQL_NGXr6zA6jlo5IfAM2ZO37sekMeta } from "/home/bun/app/pages/index.vue?macro=true";
import { default as websocketgIT6VkQEk6M_JoM7OSijVIfciBbciNeuvLWLkNocA_454Meta } from "/home/bun/app/pages/websocket.vue?macro=true";
import { default as index_RiA5aA10GSZgW7Kak2OzSsz7BW3QtGauDi_HkywQ5EMeta } from "/home/bun/app/pages/hans/index.vue?macro=true";
import { default as indexhJeHbGCz5A7syVOHUy774LAwhZN7U7MPtw_Qv6Q_Bs4Meta } from "/home/bun/app/pages/admin/index.vue?macro=true";
import { default as indexslKClT_7QW5RSnNU1Zue8bUnaNzz6GIYZamiXUVZw2EMeta } from "/home/bun/app/pages/hans/[activity]/index.vue?macro=true";
import { default as comparelMqc2kKAcslViulJlPl4czrsx0AqxVPh0x4Eywx83rMMeta } from "/home/bun/app/pages/hans/[activity]/compare.vue?macro=true";
import { default as networkflmbLMuGUp3LoEKImEn0SzN9CZB2lKPIxX8EGFVTr0UMeta } from "/home/bun/app/pages/hans/[activity]/network.vue?macro=true";
import { default as projectsJBpyPoHYK0y8x3cwaZw3XFcbq2f4flWQ7CsD7rxLWoQMeta } from "/home/bun/app/pages/hans/[activity]/projects.vue?macro=true";
import { default as equipmentsktSBLdBsxl5y7JnmHRrJC0KidSsPsFYePRYTsJe8GJIMeta } from "/home/bun/app/pages/hans/[activity]/equipments.vue?macro=true";
import { default as switchingsCOUYsFf0VZaFb_B8P_4585f2FVRvuitlrXZzftewklk0oMeta } from "/home/bun/app/pages/hans/[activity]/switchings.vue?macro=true";
import { default as topologiesHxPwt2snxeRcehdbKhgslKNgZYo2tly29p9Kulz7WvsMeta } from "/home/bun/app/pages/hans/[activity]/topologies.vue?macro=true";
import { default as subprojectsUGuBohP8SG3I1plNkl7S0zWS_45dwcrgPWq0NZu_454x_45OMMeta } from "/home/bun/app/pages/hans/[activity]/subprojects.vue?macro=true";
import { default as indexxUS5ZYi5iDC43o6oABECxmegYPdI9JhnDI_458SHfblvcMeta } from "/home/bun/app/pages/hans/[activity]/report/index.vue?macro=true";
import { default as switching_45blocksYKx1YL_45n_45a1b3c6nvvgkMxg1_VUKcs1MMdTUmDRNh6cMeta } from "/home/bun/app/pages/hans/[activity]/switching-blocks.vue?macro=true";
import { default as switchings_45ganttJWX6W81yLvlKmCQwEpYgdyOAOEUxCtbhP8s1LuZ5SbMMeta } from "/home/bun/app/pages/hans/[activity]/switchings-gantt.vue?macro=true";
import { default as switchingsoTipCpYPxxpZ97iwFhfK5V2bALddNGQvH_45Kn7PZ2mDgMeta } from "/home/bun/app/pages/hans/[activity]/report/switchings.vue?macro=true";
import { default as switching_45premisesjS_WRBDx6br65r5ZYL3hNL0dbBTm_4501vLfzRddl3uDgMeta } from "/home/bun/app/pages/hans/[activity]/switching-premises.vue?macro=true";
import { default as front_45matter39NONK3XaRsmplha7YgrkkppvxVvgBX4Hob7OQ9a1J4Meta } from "/home/bun/app/pages/hans/[activity]/report/front-matter.vue?macro=true";
import { default as network_45stateaek5kelbDTFNpgYSprGzD_e0_45QBslJiOJ3Q_fV7fsI0Meta } from "/home/bun/app/pages/hans/[activity]/report/network-state.vue?macro=true";
import { default as switchings_45ganttf9063AJllj_Lh2BfAIPNHM38_Cby_Vlm9ohZDYSjrQEMeta } from "/home/bun/app/pages/hans/[activity]/report/switchings-gantt.vue?macro=true";
import { default as topologies_45tableWy8p4RdWB0SgDUhXHmgAbvuGTmkrZMVMW42SVssuCyYMeta } from "/home/bun/app/pages/hans/[activity]/report/topologies-table.vue?macro=true";
import { default as topologies_45matrixQDQj3IV3TtgzVC66cx7wr8TEnIVEx1aN7849AQYM7owMeta } from "/home/bun/app/pages/hans/[activity]/report/topologies-matrix.vue?macro=true";
import { default as network_45topologiesXKOwhBMxgvG8ogl_45jKMnVgjWzjXrh4AqQ8CF8MIB3xAMeta } from "/home/bun/app/pages/hans/[activity]/report/network-topologies.vue?macro=true";
import { default as network_45equipment_45statusGby1QH8VWtzcgBvKN4nDNrttzEw7_pb0POdt2YtT7J0Meta } from "/home/bun/app/pages/hans/[activity]/report/network-equipment-status.vue?macro=true";
import { default as _91activity_93E_45yEHkpbpR2UVdqMqbKwmWHGfeKZdyr2BBjnGgvPQRMMeta } from "/home/bun/app/pages/hans/[activity].vue?macro=true";
import { default as user_45manual_45filesndZRzP0snfHeL5viORC_45Yhkfn_45XR_3bPv6QM39D_45o8cMeta } from "/home/bun/app/pages/user-manual-files.vue?macro=true";
import { default as user_45management4G7cAXdwChcQjs3wL6uVQccy_tn7nh_45v_WAv57X75dEMeta } from "/home/bun/app/pages/admin/user-management.vue?macro=true";
export default [
  {
    name: "auth",
    path: "/auth",
    component: () => import("/home/bun/app/pages/auth.vue"),
    children: [
  {
    name: "auth-login",
    path: "login",
    meta: loginnHf6UaBUCy38F4yExeYF_ANgwlS_9Bsvtvvio1Nx55IMeta || {},
    component: () => import("/home/bun/app/pages/auth/login.vue")
  },
  {
    name: "auth-register",
    path: "register",
    meta: registerK7qOGAV_45vWniurJYZ69CZXH5EsirWqdlXHC11NnFlh8Meta || {},
    component: () => import("/home/bun/app/pages/auth/register.vue")
  },
  {
    name: "auth-saml-jwt",
    path: "saml-jwt",
    meta: saml_45jwtoWXJf0_454XNOHcLHRSSJ9udmWbPjd1neuLjo8VIZO_458YMeta || {},
    component: () => import("/home/bun/app/pages/auth/saml-jwt.vue")
  }
]
  },
  {
    name: sinao07spVqb84g0VUqpJtTfu3bbs5u0gnrcT3dm__HhqJQMeta?.name,
    path: "/sina",
    component: () => import("/home/bun/app/pages/sina.vue"),
    children: [
  {
    name: "sina",
    path: "",
    component: () => import("/home/bun/app/pages/sina/index.vue")
  },
  {
    name: _91survey_93yolFeUVDdcUCZZuyLOvunco6_459NJ5Mn9rrNEO9so87QMeta?.name,
    path: ":survey()",
    meta: _91survey_93yolFeUVDdcUCZZuyLOvunco6_459NJ5Mn9rrNEO9so87QMeta || {},
    component: () => import("/home/bun/app/pages/sina/[survey].vue"),
    children: [
  {
    name: "sina-survey",
    path: "",
    component: () => import("/home/bun/app/pages/sina/[survey]/index.vue")
  },
  {
    name: "sina-survey-job-cluster",
    path: "job-cluster",
    component: () => import("/home/bun/app/pages/sina/[survey]/job-cluster.vue")
  },
  {
    name: "sina-survey-example-matrix",
    path: "example-matrix",
    component: () => import("/home/bun/app/pages/sina/[survey]/example-matrix.ts")
  },
  {
    name: "sina-survey-results",
    path: "results",
    component: () => import("/home/bun/app/pages/sina/[survey]/results/index.vue")
  },
  {
    name: "sina-survey-results-timeline",
    path: "results/timeline",
    component: () => import("/home/bun/app/pages/sina/[survey]/results/timeline.vue")
  },
  {
    name: "sina-survey-switching-windows",
    path: "switching-windows",
    component: () => import("/home/bun/app/pages/sina/[survey]/switching-windows.vue")
  },
  {
    name: "sina-survey-results-nnf-cne-table",
    path: "results/nnf-cne-table",
    component: () => import("/home/bun/app/pages/sina/[survey]/results/nnf-cne-table.vue")
  }
]
  }
]
  },
  {
    name: "index",
    path: "/",
    component: () => import("/home/bun/app/pages/index.vue")
  },
  {
    name: "websocket",
    path: "/websocket",
    component: () => import("/home/bun/app/pages/websocket.vue")
  },
  {
    name: "hans",
    path: "/hans",
    component: () => import("/home/bun/app/pages/hans/index.vue")
  },
  {
    name: "admin",
    path: "/admin",
    component: () => import("/home/bun/app/pages/admin/index.vue")
  },
  {
    name: _91activity_93E_45yEHkpbpR2UVdqMqbKwmWHGfeKZdyr2BBjnGgvPQRMMeta?.name,
    path: "/hans/:activity()",
    meta: _91activity_93E_45yEHkpbpR2UVdqMqbKwmWHGfeKZdyr2BBjnGgvPQRMMeta || {},
    component: () => import("/home/bun/app/pages/hans/[activity].vue"),
    children: [
  {
    name: "hans-activity",
    path: "",
    meta: indexslKClT_7QW5RSnNU1Zue8bUnaNzz6GIYZamiXUVZw2EMeta || {},
    component: () => import("/home/bun/app/pages/hans/[activity]/index.vue")
  },
  {
    name: "hans-activity-compare",
    path: "compare",
    component: () => import("/home/bun/app/pages/hans/[activity]/compare.vue")
  },
  {
    name: "hans-activity-network",
    path: "network",
    component: () => import("/home/bun/app/pages/hans/[activity]/network.vue")
  },
  {
    name: "hans-activity-projects",
    path: "projects",
    component: () => import("/home/bun/app/pages/hans/[activity]/projects.vue")
  },
  {
    name: "hans-activity-equipments",
    path: "equipments",
    component: () => import("/home/bun/app/pages/hans/[activity]/equipments.vue")
  },
  {
    name: "hans-activity-switchings",
    path: "switchings",
    component: () => import("/home/bun/app/pages/hans/[activity]/switchings.vue")
  },
  {
    name: "hans-activity-topologies",
    path: "topologies",
    component: () => import("/home/bun/app/pages/hans/[activity]/topologies.vue")
  },
  {
    name: "hans-activity-subprojects",
    path: "subprojects",
    component: () => import("/home/bun/app/pages/hans/[activity]/subprojects.vue")
  },
  {
    name: "hans-activity-report",
    path: "report",
    component: () => import("/home/bun/app/pages/hans/[activity]/report/index.vue")
  },
  {
    name: "hans-activity-switching-blocks",
    path: "switching-blocks",
    component: () => import("/home/bun/app/pages/hans/[activity]/switching-blocks.vue")
  },
  {
    name: "hans-activity-switchings-gantt",
    path: "switchings-gantt",
    component: () => import("/home/bun/app/pages/hans/[activity]/switchings-gantt.vue")
  },
  {
    name: "hans-activity-report-switchings",
    path: "report/switchings",
    component: () => import("/home/bun/app/pages/hans/[activity]/report/switchings.vue")
  },
  {
    name: "hans-activity-switching-premises",
    path: "switching-premises",
    component: () => import("/home/bun/app/pages/hans/[activity]/switching-premises.vue")
  },
  {
    name: "hans-activity-report-front-matter",
    path: "report/front-matter",
    component: () => import("/home/bun/app/pages/hans/[activity]/report/front-matter.vue")
  },
  {
    name: "hans-activity-report-network-state",
    path: "report/network-state",
    component: () => import("/home/bun/app/pages/hans/[activity]/report/network-state.vue")
  },
  {
    name: "hans-activity-report-switchings-gantt",
    path: "report/switchings-gantt",
    component: () => import("/home/bun/app/pages/hans/[activity]/report/switchings-gantt.vue")
  },
  {
    name: "hans-activity-report-topologies-table",
    path: "report/topologies-table",
    component: () => import("/home/bun/app/pages/hans/[activity]/report/topologies-table.vue")
  },
  {
    name: "hans-activity-report-topologies-matrix",
    path: "report/topologies-matrix",
    component: () => import("/home/bun/app/pages/hans/[activity]/report/topologies-matrix.vue")
  },
  {
    name: "hans-activity-report-network-topologies",
    path: "report/network-topologies",
    component: () => import("/home/bun/app/pages/hans/[activity]/report/network-topologies.vue")
  },
  {
    name: "hans-activity-report-network-equipment-status",
    path: "report/network-equipment-status",
    component: () => import("/home/bun/app/pages/hans/[activity]/report/network-equipment-status.vue")
  }
]
  },
  {
    name: "user-manual-files",
    path: "/user-manual-files",
    component: () => import("/home/bun/app/pages/user-manual-files.vue")
  },
  {
    name: "admin-user-management",
    path: "/admin/user-management",
    component: () => import("/home/bun/app/pages/admin/user-management.vue")
  }
]